export default __webpack_public_path__ + "static/media/Rectangle_28.4b011db5.png";